import { render } from "./docs-modal.vue?vue&type=template&id=788c24b4&ts=true"
import script from "./docs-modal.vue?vue&type=script&lang=ts"
export * from "./docs-modal.vue?vue&type=script&lang=ts"

import "./docs-modal.vue?vue&type=style&index=0&id=788c24b4&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__